import installCalloutVisibleDefinition from './install-callout-visible.js';
import installModalVisibleDefinition from './install-modal-visible.js';

const selectorDefinitions = [
  installModalVisibleDefinition,
  installCalloutVisibleDefinition,
];

export default selectorDefinitions;
